export function partners() {

    return [
        { value: 'hellocare', label: 'Hellocare' },
        { value: 'number118', label: 'Number 118' },
    ];
}


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/Filters/SelectList/Partners.js